// noinspection ES6ConvertVarToLetConst
import { saveScreenSize } from './actions'

import AnypointNavBar from '@mulesoft/anypoint-navbar'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { LifecycleValues, selectors as lifcycleSelectors } from '../../lifecycle/lifecycle'
import { Profile, RoleTypes, selectors as authSelectors, signOut } from '../../lifecycle/auth'
import { AppState, Dispatch } from '../../types'
import { routesWithDefaultAnypointNavBar } from '../Sidebar/Routes'
import Spinner from '@mulesoft/anypoint-components/lib/Spinner'
import UnauthorizedModal from '../UnauthorizedModal/UnauthorizedModalContainer'
import SidebarTabs from '../Sidebar/SideBar'
import '@mulesoft/anypoint-styles/anypoint-styles.css'
import './App.css'

type ValueProps = {
  profile: Profile | null,
  roles: RoleTypes[],
  hasEditRole?: boolean,
  activeOrganizationId: string,
  authorization: string,
  initializationState: LifecycleValues,
  initializationError: string
}

type EventProps = {
  signOut: () => void
  onOrganizationChange: (token: string) => void
  saveScreenSize: (width: number, height: number) => void
}

type Props = ValueProps & EventProps & RouteComponentProps<any>

class App extends React.Component<Props, {}> {

  constructor(props: Props) {
    super(props)
    this.onSignOut = this.onSignOut.bind(this)
    this.onOrganizationChange = this.onOrganizationChange.bind(this)
  }

  onSignOut() {
    this.props.signOut()
  }

  onOrganizationChange() {
    this.props.onOrganizationChange(this.props.authorization)
  }
  

  renderNavBar() {
    const {profile, activeOrganizationId} = this.props

    return (
      <AnypointNavBar
        activeProductName="monitoring_center"
        profile={profile}
        activeOrganizationId={activeOrganizationId}
        onOrganizationChange={this.onOrganizationChange}
        onSignout={this.onSignOut}
      />
    )
  }

  renderContent() {
    const {initializationState, initializationError, profile, location, roles, hasEditRole} = this.props

    switch (initializationState) {
      case LifecycleValues.Initializing:
        return (
          <div className="app-loading">
            <Spinner size="m"/>
          </div>
        )
      case LifecycleValues.InitializeError:
        return (
          <div className="app-error">
            <h3>Oops... Please try again later</h3>
            <p>{initializationError}</p>
          </div>
        )
      case LifecycleValues.Initialized:
      default:
        return profile && <SidebarTabs
          activePath={location ? location.pathname : undefined}
          profile={profile}
          roles={roles}
          hasEditRole={hasEditRole}
        />
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, prevContext: any): void {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      const width = window.screen.width * window.devicePixelRatio
      const height = window.screen.height * window.devicePixelRatio
      this.props.saveScreenSize(width, height)
    }
  }

  render() {
    return (
      <div className="app anypoint-styles">
        {this.renderNavBar()}
        {this.renderContent()}
        <UnauthorizedModal/>
      </div>
    )
  }
}

const mapState = (rootState: AppState): ValueProps => ({
  profile: authSelectors.getProfile(rootState).getOrNull(),
  roles: authSelectors.getRoles(rootState).getOrElse([]),
  activeOrganizationId: authSelectors.getOrganizationId(rootState),
  authorization: authSelectors.getAuthorization(rootState),
  hasEditRole: authSelectors.hasEditRole(rootState),
  initializationState: lifcycleSelectors.getInitializationState(rootState),
  initializationError: lifcycleSelectors.getInitializationError(rootState)
})

// bind dispatch
const mapDispatch = (dispatch: Dispatch): EventProps => ({
  signOut: () => dispatch(signOut()),
  onOrganizationChange: (token: string) => setTimeout(() => window.location.href = '/monitoring'),
  saveScreenSize: (width: number, height: number) => dispatch(saveScreenSize(width, height))
})

const component = connect(mapState, mapDispatch)(App)
export default withRouter(component as React.ComponentType<any>)
